import { Login } from "./Login";
import "./styles.scss";

export default {
  Login,
};
